/**
 * name 热点时间轴详情
 * author zhang.yingyu
 * createTime 2019-04-04
 **/
"use strict";
angular.module("timeAxisDetailModule",[])
    .controller("timeAxisDetailCtrl",["$scope","$q","trsHttpService","$filter",function($scope,$q,trsHttpService,$filter){
        initStatus();
        initData();
        /**
         * [initStatus description] 初始化状态
         * @return {[type]} [description]
         */
        function initStatus(){
            $scope.status={
                pTimeAxisIndex:0,
                timeAxisInitIndex:0,
            };
            $scope.data={
                choiceDate:"",
                choiceWeekDay:"",
                hotMap:[],
            };
        };
        /**
         * [initData description] 初始化数据
         * @return {[type]} [description]
         */
        function initData(){
            getTimeHotDate().then(function(){});
        };
        /**
         * [showTimeLineData description] 根据选中的日期，按照时间顺序展示对应日期内的数据
         * @return {[type]} [description]
         */
       function showTimeHotLineData(datetime){
            var defer=$q.defer();
            var params={
                'modelid':"showTimeLineData",
                'serviceid': 'timeline',
                'datetime':datetime
            };
           $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(),params,"get").then(function(data){
               if(data){
                   getTimeAxisPIndex(data);
                   $scope.data.timeListData=data;
                   getOfficialWeiboData(data[$scope.status.pTimeAxisIndex].value[$scope.status.timeAxisInitIndex].KEYWORDS);
               }
                defer.resolve(data);
            });
            return defer.promise;
        };
        /**
         * [getTimeAxisFIndex description] 获取当前选中的第一条数据
         */
        function getTimeAxisPIndex(data){
            for(var i=0;i<data.length;i++){
                if(data[i].value.length>=1){
                    $scope.status.pTimeAxisIndex=i;
                    break;
                }
            }
        };
        /**
         * [toHotPointDetail description] 监听点击散点图数据
         */
        $scope.$on("getChoiceDate",function(event,data){
            if(data){
                var date=data.tranDatas;
                showTimeHotLineData(date).then(function(){
                    $scope.$emit("getTrsHeight");
                });
            }
        });
        $scope.getTimeAxisDetail=function(keywords,pIndex,index){
            $scope.status.pTimeAxisIndex=pIndex;
            $scope.status.timeAxisInitIndex=index;
            getOfficialWeiboData(keywords);
        };
        /**
         * [getOfficialWeibo description] 热点关联官方微博
         * @return {[type]} [description]
         */
        function getOfficialWeiboData(keywords){
            var defer=$q.defer();
            var params={
                'modelid':"getOfficialWeibo",
                'serviceid': 'timeline',
                'keywords':keywords
            };
            $scope.loadingPromise=trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(),params,"get").then(function(data){
                $scope.data.officialWeiboData=data.PAGEITEMS;
                defer.resolve(data);
            });
            return defer.promise;
        };
        /**
         * [getHotPointTime description] 获取热点时间
         */
        $scope.getAxisPanlTime=function(type,time){
            if(!!time){
                return $filter('date')(new Date(time), 'MM-dd HH:mm:ss');
            }
        };
        /**
         * [getTimeLineDate description] 时间轴内的热点日期分布
         * @return {[type]} [description]
         */
        function getTimeHotDate(){
            var defer=$q.defer();
            var params={
                'modelid':"getTimeLineDate",
                'serviceid': 'timeline',
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(),params,"get").then(function(data){
                if(data){
                    $scope.data.hotMap=data.map(function(item,index){
                        var obj={};
                        obj={
                            time:$filter('date')(new Date(item.time), 'yyyy-MM-dd'),
                            value:parseInt(item.value),
                        };
                        return obj;
                    });
                }
                defer.resolve(data);
            });
            return defer.promise;
        };
        /**
         * [getExcel description] 到处excel
         * @return {[type]} [description]
         */
        $scope.getExcel=function(){
            var params={
                'modelid':"exportExcel",
                'serviceid': 'timeline',
            };
            var url;
            $scope.loadingPromise =trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(),params,"get").then(function(data){
                if(angular.isDefined(data)){
                    url=data.URL;
                    window.open(url);
                }
            });
        };
    }]);